import React, { Component } from "react";
// import { Form } from "react-bootstrap";
import { connect } from 'react-redux';
import { requestRegister, recordAttendance, customMiddle } from "../actions/api";
import { getCookie, setCookie } from '../reducer';
class Attendance extends Component {
  constructor(props) {
    super(props);
    let deviceCookie = getCookie('device');

    this.state = {
      deviceCookie
    };

  }

  componentDidMount() {
    if (this.state.deviceCookie.request_token && !this.state.isAttendenceOpenRequested) {
      this.setState({ isAttendenceOpenRequested: true }, (() => {

        const payload = {
          url: `recordAttendance`,
          method: "POST",
          data: { "isAttendanceOpen": true, token: this.state.deviceCookie.request_token },
          requestedBy: 'attendance'
        };
        this.props.customMiddle(payload);
      }));
    }

  }
  handleRequest() {
    this.props.requestRegister();
    var intv = setInterval(() => {
      if (this.props.registerRequestData) {
        clearInterval(intv);
        setCookie('device', JSON.stringify(this.props.registerRequestData), 60 * 60 * 24 * 365);
        this.setState({ deviceCookie: this.props.registerRequestData })
      }
    }, 1000);

  }

  handlePresent() {
    const payload = {
      url: `recordAttendance`,
      method: "POST",
      data: { token: this.state.deviceCookie.request_token },
      requestedBy: 'attendance'
    };
    this.props.customMiddle(payload);
  }

  render() {
    const { isAttendanceOpen, isAttendanceRecorded, isRegistered } = this.props.attendance || {};
    var comp = null;
    if (this.state.deviceCookie.request_token) {
      if (!isRegistered) {
        const otp = this.state.deviceCookie.otp;
        comp = (
          <>
            <h3>Your request is submited, please contact admin to give approval.</h3>
            <h3>your otp is {otp}</h3>
          </>
        )
      }
      if (isAttendanceRecorded) {
        comp = <h3>Attendance recorded</h3>;
      }
      else if (isAttendanceOpen) {
        comp = (
          <button className="btn btn-success" onClick={() => this.handlePresent()}>Present</button>
        )
      }
      else
        comp = <h3>Attendance for today is closed.</h3>
    }
    else {
      comp = (
        <button className="btn btn-primary" onClick={() => this.handleRequest()}>Request access</button>
      )
    }
    return comp;
  }
}

const mapStateToProps = ({ reducer: store }) => {
  return {
    registerRequestData: store.registerRequestData,
    attendance: store.customMiddle.attendance,
  };
};
export default connect(mapStateToProps, { requestRegister, recordAttendance, customMiddle }, null, {
  areStatesEqual: (next, prev) => {

    const equal = (next.reducer.registerRequestData === prev.reducer.registerRequestData)
      && (next.reducer.customMiddle.attendance === prev.reducer.customMiddle.attendance);
    return equal;
  }
})(Attendance);
